"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _merchantElectricity = require("@/api/merchantElectricity");
var _utils = require("./utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MerchantElectricityWithdrawRecords',
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      listLoading: false,
      list: [],
      tableMaxH: 400,
      listQuery: {
        start: 1,
        limit: 20,
        page_num: 0,
        total: 0
      }
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    formatMoney: _utils.formatMoney,
    formatKwh: _utils.formatKwh,
    formatAccount: _utils.formatAccount,
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      var params = {
        start: this.listQuery.start - 1,
        limit: this.listQuery.limit
      };
      (0, _merchantElectricity.getWithdrawRecordList)(params).then(function (res) {
        _this.list = res && res.list || [];
        var total = res && res.total != null ? res.total : 0;
        _this.listQuery.total = total;
        _this.listQuery.page_num = Math.ceil(total / _this.listQuery.limit) || 0;
        if (params.start === 0 && _this.$refs.list_table) {
          _this.$nextTick(function () {
            _this.tableMaxH = window.innerHeight - _this.$refs.list_table.$el.offsetTop - 80;
          });
        }
      }).catch(function (err) {
        _this.$message.error(err && err.msg || '加载失败');
      }).finally(function () {
        _this.listLoading = false;
      });
    }
  }
};